import { APP_PDC_URL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
export const tagsConstants = {
  GET_STANDARD_TAGS_START: "GET_STANDARD_TAGS_START",
  GET_STANDARD_TAGS_SUCCESS: "GET_STANDARD_TAGS_SUCCESS",
  GET_STANDARD_TAGS_ERROR: "GET_STANDARD_TAGS_ERROR"
};

export function getStandardTags(
  auth,
  companySelected,
  clientIdSelected,
  typeDocument
) {
  return dispatch => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: tagsConstants.GET_STANDARD_TAGS_START
      });
      let request = {
        method: "get",
        url:
        APP_PDC_URL +
          "/tags?docType=" +
          typeDocument +
          "&itemId=" +
          clientIdSelected,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200) {
            dispatch({
              type: tagsConstants.GET_STANDARD_TAGS_SUCCESS,
              payload: result.data
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: tagsConstants.GET_STANDARD_TAGS_ERROR,
            payload: {
              code: response.code ? response.code : null,
              message: response.message
            }
          });
          reject();
        });
    });
  };
}
